import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";

import "@firebase/polyfill";

import { unregister } from "./registerServiceWorker";

import "semantic-ui-css/semantic.min.css";
import "./index.css";

if (process.env.NODE_ENV == "production")
	(window as any).Raven.config(
		"https://7f3cec022c5d4ed2ac655fcbdd935793@sentry.io/1205434"
	).install({
		environment: process.env.NODE_ENV == "production" ? "prod" : "dev"
	});

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);

unregister();



// WEBPACK FOOTER //
// ./src/index.tsx